import { gsap } from "animations/gsap";
import { ConfigInt } from "interfaces";

gsap.registerEffect({
  name: "fadeIn",
  defaults: { duration: 0.2 },
  effect: (target: any, config: ConfigInt) => {
    return gsap.fromTo(
      target,
      { opacity: 0 },
      {
        opacity: 1,
        duration: config.duration,
      }
    );
  },
  extendTimeline: true,
});

gsap.registerEffect({
  name: "fadeOut",
  defaults: { duration: 0.2 },
  effect: (target: any, config: ConfigInt) => {
    return gsap.fromTo(
      target,
      { opacity: 1 },
      {
        opacity: 0,
        duration: config.duration,
      }
    );
  },
  extendTimeline: true,
});

gsap.registerEffect({
  name: "scrollIn",
  effect: (target: any) => {
    return gsap.fromTo(
      target,
      {
        yPercent: 50,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.4,
      }
    );
  },
  extendTimeline: true,
});

gsap.registerEffect({
  name: "scrollOut",
  effect: (target: any) => {
    return gsap.fromTo(
      target,
      { yPercent: 0, opacity: 1 },
      {
        yPercent: -25,
        opacity: 0,
        duration: 0.3,
      }
    );
  },
  extendTimeline: true,
});
